import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon } from "../../components"

/* Moment */
import moment from "moment"
import "moment/locale/ru"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"

/* REST API */
import { organizations } from "../../api/Booking"

/* Shared */
import { STATUSES, CHANNELS } from "./shared"

registerLocale("ru", ru)
moment.locale("ru")
Modal.setAppElement("#root")


/* The periods the records are looked at by. The month is the one the page opens on */
export const PERIODS = [
    { key: "month", text: "Этот месяц" },
    { key: "prev", text: "Прошлый месяц" },
    { key: "week", text: "Эта неделя" },
    { key: "today", text: "Сегодня" },
    { key: "tomorrow", text: "Завтра" },
    { key: "year", text: "Этот год" },
    { key: "period", text: "Свой период" }
]


/* The dates one period stands for */
export const periodDates = key => {

    if (key === "today") {
        return { startDate: moment().startOf("day").toDate(), endDate: moment().endOf("day").toDate() }
    }

    if (key === "tomorrow") {
        return { startDate: moment().add(1, "day").startOf("day").toDate(), endDate: moment().add(1, "day").endOf("day").toDate() }
    }

    if (key === "week") {
        return { startDate: moment().startOf("week").toDate(), endDate: moment().endOf("week").toDate() }
    }

    if (key === "prev") {
        return { startDate: moment().subtract(1, "month").startOf("month").toDate(), endDate: moment().subtract(1, "month").endOf("month").toDate() }
    }

    if (key === "year") {
        return { startDate: moment().startOf("year").toDate(), endDate: moment().endOf("year").toDate() }
    }

    return { startDate: moment().startOf("month").toDate(), endDate: moment().endOf("month").toDate() }
}


/* The filter the page of the records opens on — the current month, every point,
   every status, every channel */
export const INITIAL_FILTER = { period: "month", organizationID: "all", status: "all", channel: "all", ...periodDates("month") }


/* HOW MANY VALUES of the filter differ from the empty one — the button of the page shows it */
export const filterCount = filter => {

    let count = filter.period === INITIAL_FILTER.period ? 0 : 1

    if (`${filter.organizationID}` !== "all") {
        count = count + 1
    }

    if (`${filter.status}` !== "all") {
        count = count + 1
    }

    if (`${filter.channel}` !== "all") {
        count = count + 1
    }

    return count
}


/* WHAT THE PERIOD IS CALLED — the name of a whole month or the dates of an own one */
export const periodTitle = filter => {

    const period = PERIODS.find(item => item.key === filter.period)

    if (period && period.key !== "period") {
        return period.text
    }

    return `${moment(filter.startDate).format("DD.MM.YY")} — ${moment(filter.endDate).format("DD.MM.YY")}`
}


/* Widget Filter Modal — the point, the period, the state and the channel of the records.
   It is opened by the reference: this._filter.current.open(filter) */
class FilterModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            picker: false,
            filter: { ...INITIAL_FILTER },

            /* The points are read once and kept for the whole life of the page */
            list: [],
            search: ""
        }
    }

    /* Open the filter on what the page is showing now */
    open = filter => {

        this.setState({ visible: true, picker: false, search: "", filter: { ...INITIAL_FILTER, ...filter } }, () => this.load())
    }

    /* Close the filter */
    close = () => {
        this.setState({ visible: false })
    }

    /* The points of the platform — they are asked for only once */
    load = () => {

        /* Fields */
        const { list } = this.state

        /* Check Data */
        if (list.length > 0) {
            return
        }

        organizations().then(response => {
            if (response && response.status === 200) {
                this.setState({ list: response.data.list })
            }
        }).catch(() => this.setState({ list: [] }))
    }

    /* Choose one value of the filter */
    set = (key, value) => {
        this.setState(previous => ({ filter: { ...previous.filter, [key]: value } }))
    }

    /* Choose the organization in its own window and close that window right away */
    choose = id => {
        this.set("organizationID", id)
        this.setState({ picker: false, search: "" })
    }

    /* Choose the period — its dates are filled in at once */
    period = key => {

        /* The own period keeps the dates which are already chosen */
        if (key === "period") {
            this.set("period", key)
            return
        }

        this.setState(previous => ({ filter: { ...previous.filter, period: key, ...periodDates(key) } }))
    }

    /* Give the chosen filter to the page */
    apply = () => {

        const { filter } = this.state
        const { onApply } = this.props

        this.setState({ visible: false })
        onApply(filter)
    }

    /* Drop everything back to the current month */
    reset = () => {

        const { onApply } = this.props

        this.setState({ visible: false, search: "", filter: { ...INITIAL_FILTER } })
        onApply({ ...INITIAL_FILTER })
    }

    /* The point of the record — it opens in its own window since the list is long */
    _organizations = () => {

        /* Fields */
        const { list, filter } = this.state

        const chosen = list.find(item => `${item.id}` === `${filter.organizationID}`)

        return (
            <div className="filter-modal-row">

                <div className="filter-modal-row-text">Организация</div>

                <div onClick={() => this.setState({ picker: true, search: "" })} className="booking-filter-select">
                    <span>{chosen ? chosen.name : "Все организации"}</span>
                    <div className="booking-filter-select-arrow">
                        <Icon name="right" size={14} width={2} />
                    </div>
                </div>

            </div>
        )
    }

    /* The window with the organizations — search on top, the list right under it */
    _organizationPicker = () => {

        /* Fields */
        const { picker, list, search, filter } = this.state

        const found = search.length > 0
            ? list.filter(item => `${item.name}`.toLowerCase().indexOf(search.toLowerCase()) > -1)
            : list

        return (
            <Modal
                isOpen={picker}
                onRequestClose={() => this.setState({ picker: false })}
                className="filter-modal organization-picker-modal"
                overlayClassName="filter-modal-overlay organization-picker-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Организация</h2>
                    <div onClick={() => this.setState({ picker: false })} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    <div className="booking-filter-search">

                        <Icon name="search" size={16} />

                        <input
                            autoFocus
                            placeholder="Поиск по названию"
                            value={search}
                            onChange={event => this.setState({ search: event.target.value })}
                        />

                        {search.length > 0 &&
                            <div onClick={() => this.setState({ search: "" })} className="booking-filter-clear">
                                <Icon name="close" size={10} width={2.4} />
                            </div>
                        }

                    </div>

                    <div className="booking-filter-list">

                        <div
                            onClick={() => this.choose("all")}
                            className={`booking-filter-option ${`${filter.organizationID}` === "all" ? "active" : ""}`}
                        >
                            Все организации
                        </div>

                        {found.slice(0, 60).map(item =>
                            <div
                                key={`${item.id}`}
                                onClick={() => this.choose(item.id)}
                                className={`booking-filter-option ${`${filter.organizationID}` === `${item.id}` ? "active" : ""}`}
                            >
                                {item.name}
                            </div>
                        )}

                        {found.length === 0 && <div className="booking-filter-empty">Ничего не найдено</div>}

                    </div>

                </div>

            </Modal>
        )
    }

    render = () => {

        /* Fields */
        const { visible, filter } = this.state

        return (
            <>
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="filter-modal"
                overlayClassName="filter-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="filter-modal-header">
                    <h2>Фильтры записей</h2>
                    <div onClick={this.close} className="filter-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                <div className="filter-modal-body">

                    {this._organizations()}

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Период</div>

                        <div className="filter-modal-chips">
                            {PERIODS.map(period =>
                                <div
                                    key={period.key}
                                    onClick={() => this.period(period.key)}
                                    className={`filter-modal-chip ${filter.period === period.key ? "active" : ""}`}
                                >
                                    {period.text}
                                </div>
                            )}
                        </div>

                        <div className="filter-modal-dates">

                            <div className="filter-modal-date">
                                <span>С</span>
                                <DatePicker
                                    withPortal
                                    portalId="datepicker-portal"
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.startDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", startDate: date } }))}
                                />
                            </div>

                            <div className="filter-modal-date">
                                <span>По</span>
                                <DatePicker
                                    withPortal
                                    portalId="datepicker-portal"
                                    locale="ru"
                                    dateFormat="dd.MM.yyyy"
                                    selected={filter.endDate}
                                    onChange={date => this.setState(previous => ({ filter: { ...previous.filter, period: "period", endDate: date } }))}
                                />
                            </div>

                        </div>

                    </div>

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Статус записи</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("status", "all")} className={`filter-modal-chip ${`${filter.status}` === "all" ? "active" : ""}`}>Все</div>

                            {STATUSES.map(item =>
                                <div
                                    key={`${item.status}`}
                                    onClick={() => this.set("status", item.status)}
                                    className={`filter-modal-chip ${`${filter.status}` === `${item.status}` ? "active" : ""}`}
                                >
                                    {item.text}
                                </div>
                            )}

                        </div>

                    </div>

                    <div className="filter-modal-row">

                        <div className="filter-modal-row-text">Канал записи</div>

                        <div className="filter-modal-chips">

                            <div onClick={() => this.set("channel", "all")} className={`filter-modal-chip ${filter.channel === "all" ? "active" : ""}`}>Все</div>

                            {Object.keys(CHANNELS).map(key =>
                                <div
                                    key={key}
                                    onClick={() => this.set("channel", key)}
                                    className={`filter-modal-chip ${filter.channel === key ? "active" : ""}`}
                                >
                                    {CHANNELS[key]}
                                </div>
                            )}

                        </div>

                    </div>

                </div>

                <div className="filter-modal-footer">
                    <div onClick={() => this.reset()} className="filter-modal-button light">Сбросить</div>
                    <div onClick={() => this.apply()} className="filter-modal-button">Показать</div>
                </div>

            </Modal>
            {this._organizationPicker()}
            </>
        )
    }
}

export default FilterModal
